module.exports = __webpack_public_path__ + "static/img/arrowFail.d4b708a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrowFail.png
// module id = Tclz
// module chunks = 1